import { CamposGenericos } from "./camposGenericos";

export class CuentaDistribuidor extends CamposGenericos {
    calleNro: string;
    ciudad: string;
    directo: boolean;

    funcionPartner: string;
    idCompania: string;
    idDivision: string;
    idGrupoCliente: string;
    idPais: string;
    idRegion: string;
    idSalesOffice: string;
    idSalesOrg: string;
    idZonaVendedor: string;
    nombre: string;
    nombreCliente: string;
    nroClienteCuenta: string;
    nroClienteDistribuidor: string;
    status: string;
    vendedor: boolean;
    codigoBodegaCoagra: string;
    codigoBodegaMyV: string;
}